import { useEffect, useState } from 'react';
import diffecenceInSeconds from 'date-fns/differenceInSeconds';

const calculateTimeLeft = (dateTo) => {
  const timeDifference = diffecenceInSeconds(new Date(dateTo), new Date());
  return timeDifference > 0 ? timeDifference : 0;
};

export const useCellTimer = (expireDate) => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(expireDate));

  useEffect(() => {
    // Needed when expire date change, so we would not wait a second for new value
    setTimeLeft(calculateTimeLeft(expireDate));

    const timer = setInterval(() => {
      const seconds = calculateTimeLeft(expireDate);
      setTimeLeft(seconds);
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, [expireDate]);
  return { timeLeft };
};
